import { Button, Grid, InputAdornment, TextField } from "@material-ui/core";
import { Search, GetAppOutlined, RefreshOutlined, PublishOutlined, AddOutlined } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDebounce } from "../../../hooks";
import { getPromptTypeList } from "../utility/lookupHelper";
import SelectSettingsForm from "./SelectSettingsForm";
const promptTypeList = getPromptTypeList();

const PromptsTableActionHeader = ({
	languages,
	namespaces,
	onExport,
	onRefresh,
	onFileImport,
	fileProcessingState,
	setFilterTerm,
	config,
	onSelect,
	onPromptAdd,
	setFilterType,
	filterType,
}) => {
	const [searchTerm, setSearchTerm] = useState("");

	const debouncedSearchTerm = useDebounce(searchTerm, 200);
	const isProcessing = fileProcessingState === "unprocessed" || fileProcessingState === "inprogress";

	useEffect(() => {
		setFilterTerm(debouncedSearchTerm);
	}, [debouncedSearchTerm, setFilterTerm]);

	const onSearchChanged = (e) => {
		setSearchTerm(e.target.value);
	};

	return (
		<Grid container justifyContent="space-between">
			<div className="col-7 d-flex justify-content-start align-items-end">
				<SelectSettingsForm
					languages={languages}
					namespaces={namespaces}
					config={config}
					onSelect={onSelect}
					filterType={filterType}
					setFilterType={setFilterType}
					promptTypeList={promptTypeList}
				/>
				<div className="col-6 mt-2">
					<TextField
						onFocus={(e) => e.target.select()}
						autoComplete="new-password"
						fullWidth
						onChange={onSearchChanged}
						label="Search by ID or Prompt"
						InputProps={{
							style: { height: 29 },
							startAdornment: (
								<InputAdornment position="start">
									<Search />
								</InputAdornment>
							),
						}}
					/>
				</div>
			</div>
			<div className="col-5 d-flex flex-wrap justify-content-end mt-3 pt-3">
				<Button variant="outlined" size="small" className="ml-2" onClick={onExport} startIcon={<GetAppOutlined />}>
					Export
				</Button>
				<Button variant="outlined" size="small" className="ml-2" onClick={onRefresh} startIcon={<RefreshOutlined />}>
					Refresh
				</Button>
				<Button
					disabled={isProcessing}
					variant="outlined"
					size="small"
					className="ml-2"
					onClick={onFileImport}
					startIcon={isProcessing ? <Spinner size="sm" animation="border" /> : <PublishOutlined />}
				>
					Import
				</Button>
				<Button variant="outlined" size="small" className="ml-2" onClick={onPromptAdd} startIcon={<AddOutlined />}>
					New
				</Button>
			</div>
		</Grid>
	);
};

export default PromptsTableActionHeader;
